import { Player } from "../players/models";
import { MatchOfferHeader } from "./models";
import { LeagueWithPlayersICanPlay } from "../leagues/models";

export const canBeTurnedIntoMatch = (offer: MatchOfferHeader, player?: Player, league?: LeagueWithPlayersICanPlay) =>
    offer.clubs && 
    offer.startDate &&
    offer.endDate &&
    offer.startTime &&
    offer.endTime &&
    //offer.clubs.length === 1 && 
    !!player && player.id !== offer.firstPlayer.id &&
    !!league && !!league.players.find(p => p.id === player.id) && 
    !!league.players.find(p => p.canIPlay && p.id === offer.firstPlayer.id);
    
export const canBeCancelled = (offer: MatchOfferHeader, player?: Player) => 
    player && offer.firstPlayer.id === player.id;

export interface MatchOffersFilterModel {
    dateFrom: Date;
    dateTo: Date;
    clubIds: string[]
}